import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SEAT_STATUSES, type SeatStatus } from "../lib/api";

export default function SeatMatrixEditBar({
  selectedCount,
  onApply,
  onClear,
}: {
  selectedCount: number;
  onApply: (status: SeatStatus, note?: string) => Promise<void>;
  onClear: () => void;
}) {
  const { t } = useTranslation();
  const [status, setStatus] = useState<SeatStatus>("blocked");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  if (selectedCount === 0) return null;

  return (
    <div className="edit-bar">
      <span>{t("hallPlan.edit.selected", { count: selectedCount })}</span>
      <select value={status} onChange={(e) => setStatus(e.target.value as SeatStatus)}>
        {SEAT_STATUSES.map((s) => (
          <option key={s} value={s}>
            {t(`hallPlan.legend.${s}`)}
          </option>
        ))}
      </select>
      {status === "reserved" && (
        <input
          type="text"
          className="edit-bar-note"
          placeholder={t("hallPlan.edit.reservedNotePlaceholder")}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={120}
        />
      )}
      <button
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            await onApply(status, status === "reserved" ? note : undefined);
            setNote("");
          } finally {
            setBusy(false);
          }
        }}
      >
        {t("hallPlan.edit.apply")}
      </button>
      <button className="edit-bar-clear" onClick={onClear}>
        {t("hallPlan.edit.clearSelection")}
      </button>
    </div>
  );
}
